var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isBlank)?_c('div',[_c('router-view')],1):_c('div',[_c('layout-header'),_c('v-main',{style:(`min-height: calc(100vh - ${_vm.footerHeight}px)`)},[_c('layout-breadcrumb'),_c('div',{staticClass:"px-6",staticStyle:{"padding-bottom":"120px"}},[_c('router-view')],1)],1),_c('layout-footer',{ref:"footer"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }